import { Directive, ElementRef, Renderer2, Input, OnInit} from '@angular/core';

@Directive({selector: '[appOrdertrack]'})
export class OrdertrackDirective implements OnInit{
  @Input('ostid') osid;
  @Input('oCrntStates') oCrntStates:any[];

  constructor(private renderer: Renderer2, private elmRef:ElementRef) {}
 
  ngOnInit() {

    this.oCrntStates.map((el) =>{
      if (el.orderstatus == this.osid){
        // this.renderer.setStyle(this.elmRef.nativeElement, 'color', 'green');  // to set inline css to element
        this.renderer.addClass(this.elmRef.nativeElement, 'progtrckr-done');
        this.renderer.removeClass(this.elmRef.nativeElement, 'progtrckr-todo');
      }
    });
  }

}